import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { Input, Select, Text } from "components/base/Form";
import InputSelect from "components/base/InputSelect";
import Spinner from "components/base/Spinner";
import useFactories from "hooks/useFactories";
import { useState } from "react";
import PricesForm from "./PricesForm";

const EditCostView = ({ initialValues, saveHandler }) => {
  const [state, setState] = useState(initialValues);
  const { loading, error, allFactories } = useFactories();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div className=" space-y-6">
      <div className="flex space-x-3 items-center">
        <label>Supplier: </label>
        <InputSelect
          placeholder="Input a new supplier or select from existing ones"
          className="w-full"
          value={state.supplierName}
          options={allFactories}
          onChange={(value) => {
            setState({
              ...state,
              supplierName: value,
              supplierId: allFactories.find((f) => f.name === value)?.id,
            });
          }}
          onSelect={(supplier) => {
            // If choose, set supplierId
            setState({
              ...state,
              supplierId: supplier.id,
              supplierName: supplier.name,
            });
          }}
        />
      </div>

      <div className="flex space-x-3 items-center">
        <label>Leadtime: </label>
        <Input
          className="text-center"
          value={state.leadtime}
          onChange={(e) => {
            setState({ ...state, leadtime: e.target.value });
          }}
        />
        <span>Days</span>
      </div>

      <div className="flex items-center space-x-6">
        <div className="flex space-x-3 items-center">
          <label>MOQ: </label>
          <Input
            className="text-center"
            value={state.moq}
            onChange={(e) => setState({ ...state, moq: e.target.value })}
          />
        </div>

        <div className="flex space-x-3 items-center">
          <label>Currency: </label>
          <Select
            value={state.currency}
            onChange={(e) => setState({ ...state, currency: e.target.value })}
          >
            <option value="USD">USD</option>
            <option value="CNY">CNY</option>
          </Select>
        </div>
      </div>

      <div className="-mx-2 text-sm">
        <PricesForm
          prices={state.prices}
          onChange={(prices) => setState({ ...state, prices })}
        />
      </div>

      <div>
        <label>Notes: </label>
        <Text
          className="mt-2"
          value={state.notes}
          onChange={(e) => {
            setState({ ...state, notes: e.target.value });
          }}
        />
      </div>

      <div>
        <Button primary onClick={() => saveHandler(state)}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default EditCostView;
